import { render } from "./ModalCallRequest.vue?vue&type=template&id=1ccd0144&scoped=true"
import script from "./ModalCallRequest.vue?vue&type=script&lang=js"
export * from "./ModalCallRequest.vue?vue&type=script&lang=js"

import "./ModalCallRequest.vue?vue&type=style&index=0&id=1ccd0144&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccd0144"]])

export default __exports__